import React from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon';
import SVG from '@atlaskit/icon/svg';

// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: Replace with @atlaskit/icon-lab/rephrase once it is available.
const RephraseIcon = (props: NewCoreIconProps) => {
	const { color, label } = props;
	return (
		// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
		<SVG primaryColor={color} label={label}>
			<path
				d="M12.5 5.5L14.0581 3.94194C14.3021 3.69786 14.3021 3.30214 14.0581 3.05806L12.9419 1.94194C12.6979 1.69786 12.3021 1.69786 12.0581 1.94194L10.5 3.5M12.5 5.5L7.01762 10.9824C6.84312 11.1569 6.62087 11.2758 6.37888 11.3242L4.25 11.75L4.67578 9.62112C4.72417 9.37913 4.84312 9.15688 5.01762 8.98238L10.5 3.5M12.5 5.5L10.5 3.5M1 14.25H6M12 14.25H10.5M15 14.25H13.5M9 14.25H7.5"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linejoin="round"
				transform="translate(4,4)"
			/>
		</SVG>
	);
};

export default RephraseIcon;
